"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../../core/button"));
var _offerPlaceModal = _interopRequireDefault(require("./offer-place-modal"));
var _retractOfferModal = _interopRequireDefault(require("./retract-offer-modal"));
var _acceptEntryModal = _interopRequireDefault(require("./accept-entry-modal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // This displays the appropriate button to allow the user to offer a place to a
// paddler requiring payment (or retract the place)
// or to accept a postal entry or entry that does not require payment
// As well as alongside the rows in the entry tables the buttons generated may
// be added to the end of the promotion management process.
class WaitingListManagement extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      offerPlace: false,
      retractOffer: false,
      acceptEntry: false
    });
    _defineProperty(this, "_onToggleOfferPlace", () => {
      if (this.state.offerPlace && this.props.onCloseCancel) {
        this.props.onCloseCancel();
      } else {
        this.setState({
          offerPlace: !this.state.offerPlace
        });
      }
    });
    _defineProperty(this, "_onToggleRetractOffer", () => {
      if (this.state.retractOffer && this.props.onCloseCancel) {
        this.props.onCloseCancel();
      } else {
        this.setState({
          retractOffer: !this.state.retractOffer
        });
      }
    });
    _defineProperty(this, "_onToggleAcceptEntry", () => {
      if (this.state.acceptEntry && this.props.onCloseCancel) {
        this.props.onCloseCancel();
      } else {
        this.setState({
          acceptEntry: !this.state.acceptEntry
        });
      }
    });
  }
  render() {
    const entry = this.props.entry;
    const today = new Date().toISOString().split('T')[0];
    return /*#__PURE__*/_react.default.createElement("span", null, this.state.offerPlace ? /*#__PURE__*/_react.default.createElement(_offerPlaceModal.default, {
      entryID: entry.id,
      onToggleOfferPlace: this._onToggleOfferPlace
    }) : this.state.retractOffer ? /*#__PURE__*/_react.default.createElement(_retractOfferModal.default, {
      entryID: entry.id,
      onToggleRetractOffer: this._onToggleRetractOffer
    }) : this.state.acceptEntry ? /*#__PURE__*/_react.default.createElement(_acceptEntryModal.default, {
      entry: entry,
      onToggleAcceptEntry: this._onToggleAcceptEntry
    }) : null, entry.isOnlineEntry && !entry.competitionDivision.isFreeToEnter ? entry.canEnterFromWaitingList ? /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onToggleRetractOffer,
      block: this.props.block === false ? false : true,
      size: this.props.buttonSize || 'sm'
    }, "Retract Place Offer") : /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onToggleOfferPlace,
      block: this.props.block === false ? false : true,
      disabled: entry.entryTypeOverride.openForOnlineEntryDate > today,
      size: this.props.buttonSize || 'sm',
      type: this.props.type || 'secondary'
    }, "Offer Place") : /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onToggleAcceptEntry,
      block: this.props.block === false ? false : true,
      disabled: entry.entryTypeOverride.openForOnlineEntryDate > today,
      size: this.props.buttonSize || 'sm',
      type: this.props.type || 'secondary'
    }, "Accept Entry"));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(WaitingListManagement, "partialQueries", {
  Entry: _mergeBqlQueries({
    id: true,
    isOnlineEntry: true,
    canEnterFromWaitingList: true,
    entryTypeOverride: {
      openForOnlineEntryDate: true
    },
    competitionDivision: {
      isFreeToEnter: true
    }
  }, _acceptEntryModal.default.partialQueries.Entry)
});
var _default = exports.default = (0, _reactBicycle.connect)(WaitingListManagement);